import { AssessmentTestContextType } from '..';
import { queueForSync } from '../helpers';

export type StartTestActionType = {
  type: 'START_TEST';
  timestamp: Date;
};

export function startTestReducer(
  state: AssessmentTestContextType,
  action: StartTestActionType
): AssessmentTestContextType {
  if (state.screen.type !== 'INTRO') {
    throw new Error('START_TEST can only be called when in step screen');
  }

  const [firstStep] = state.steps;
  return {
    ...state,
    ...queueForSync(state),
    startedAt: action.timestamp,
    screen: {
      type: 'STEP',
      stepId: firstStep.id,
      sectionId: null,
      stepIndex: 0,
    },
  };
}
